import { ProviderCredentialFormData } from '../../../integrated-client/models/ProviderCredentialFormData';

export interface IProviderCredentialsEditorData {
  providerCredentialsData?: ProviderCredentialFormData
  validation?: any
}
export class ProviderCredentialsEditorData implements IProviderCredentialsEditorData {

  providerCredentialsData?: ProviderCredentialFormData
  validation?: any
}
